import { render, staticRenderFns } from "./JobInviteRow.vue?vue&type=template&id=50bc2dec&"
import script from "./JobInviteRow.vue?vue&type=script&lang=js&"
export * from "./JobInviteRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports